import DropdownContainer from "../../components/uiKits/dropdown";

const Dropdown = () => {
  return <DropdownContainer />;
};

export default Dropdown;
